import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

const WeeklyTransactionChart = ({ stats }) => {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Weekly Transaction Trends
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Number of transactions detected per week (last 4 weeks)
        </Typography>
        <Box height={300}>
          <Chart
            options={{
              chart: {
                type: 'line',
              },
              xaxis: {
                categories:
                  stats?.weeklyTransactions?.map(item => item.week) || [],
              },
              colors: [theme.palette.primary?.main || '#2196f3'],
              stroke: {
                curve: 'smooth',
                width: 2,
              },
              dataLabels: {
                enabled: false,
              },
              legend: {
                position: 'top',
              },
            }}
            series={[
              {
                name: 'Transactions',
                data:
                  stats?.weeklyTransactions?.map(item => item.transactions) ||
                  [],
              },
            ]}
            type="line"
            height={300}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default WeeklyTransactionChart;
